import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue";
import { ref, computed, useTemplateRef } from 'vue';
import { trlMessage } from '@/services/i18n';
import { updateUser } from '@/utils/user';
import { clearLocalStorage } from '@/utils/local-storage';
import HelpLink from '@/components/help-link/help-link.vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'base-menu',
    setup(__props) {
        const router = useRouter();
        const menu = useTemplateRef('menu');
        const isMobileMenuOpen = ref(false);
        const menuList = computed(() => router.options.routes.filter((item) => item.meta?.menu));
        function handleClickLogout(e) {
            e.preventDefault();
            updateUser();
            clearLocalStorage();
            router.push({ name: 'login' });
        }
        function toggleMobileMenu() {
            isMobileMenuOpen.value = !isMobileMenuOpen.value;
            if (isMobileMenuOpen.value) {
                document.addEventListener('click', closeMenuOutside);
            }
            else {
                document.removeEventListener('click', closeMenuOutside);
            }
        }
        function closeMenuOutside(event) {
            const target = event.target;
            if (!target) {
                return;
            }
            if (!menu.value?.contains(target)) {
                isMobileMenuOpen.value = false;
                document.removeEventListener('click', closeMenuOutside);
            }
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("nav", {
                ref_key: "menu",
                ref: menu,
                class: _normalizeClass([_ctx.$style.menuWrapper, isMobileMenuOpen.value ? _ctx.$style.open : ''])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style.mobileIcon),
                    onClick: toggleMobileMenu
                }, [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("span", null, null, -1),
                        _createElementVNode("span", null, null, -1),
                        _createElementVNode("span", null, null, -1)
                    ]))], 2),
                _createElementVNode("ul", {
                    class: _normalizeClass(_ctx.$style.menu)
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (route) => {
                        return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(_ctx.$style.item),
                            key: route.path
                        }, [
                            _createVNode(_component_router_link, {
                                to: route.path,
                                class: _normalizeClass(_ctx.$style.link)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(route.meta.title), 1)
                                ]),
                                _: 2
                            }, 1032, ["to", "class"])
                        ], 2));
                    }), 128)),
                    _createElementVNode("li", {
                        class: _normalizeClass(_ctx.$style.item)
                    }, [
                        _createVNode(HelpLink, {
                            class: _normalizeClass(_ctx.$style.link)
                        }, null, 8, ["class"])
                    ], 2),
                    _createElementVNode("li", {
                        class: _normalizeClass(_ctx.$style.item)
                    }, [
                        _createElementVNode("span", {
                            class: _normalizeClass(_ctx.$style.link),
                            onClick: handleClickLogout
                        }, _toDisplayString(_unref(trlMessage)('button.logout')), 3)
                    ], 2)
                ], 2)
            ], 2));
        };
    }
});
